<template>
  <v-list-item
    v-if="!adminOnly || hasRoleAdmin"
    :to="link"
    density="compact"
    :append-icon="appendIcon"
    :disabled="locked"
    class="navigation-item"
  >
    <slot>
      <font-awesome-icon
        v-if="icon"
        :icon="['fas', icon]"
        size="lg"
        class="mr-8"
      />
    </slot>
    <v-list-item-title
      class="font-weight-bold text-subtitle-1"
    >
      {{ title }}
    </v-list-item-title>
  </v-list-item>
</template>

<script>
import { useAuthStore } from '@/store/auth.module';
export default {
  name: 'NavigationItem',
  props: {
    adminOnly: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    icon: {
      type: String,
      default: null,
    },
    locked: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasRoleAdmin() {
      return useAuthStore().hasRoleAdmin;
    },
    appendIcon() {
      return this.locked ? 'fas fa-lock' : '';
    }
  },
};
</script>

<style lang="scss">
.navigation-item{
  .v-list-item__content{
    display: flex;
  }
}
</style>
